import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ProgressPathProps {
  totalSteps: number;
  currentStep: number;
}
const ProgressPath: React.FC<ProgressPathProps> = ({
  totalSteps,
  currentStep
}) => {
  return <div className="flex items-center justify-center mb-8 px-4" data-id="element-809">
      <div className="w-full max-w-3xl flex items-center justify-between relative" data-id="element-810">
        {/* Background path */}
        <div className="absolute h-1 bg-white bg-opacity-20 w-full rounded-full" data-id="element-811"></div>
        {/* Progress overlay */}
        <div className="absolute h-1 bg-gradient-to-r from-pink-500 to-orange-500 rounded-full transition-all duration-500" style={{
        width: `${currentStep / (totalSteps - 1) * 100}%`
      }} data-id="element-812"></div>
        {/* Step indicators */}
        {Array.from({
        length: totalSteps
      }).map((_, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        return <div key={index} className="relative z-10 flex flex-col items-center" data-id="element-813">
              <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300
                  ${isCompleted ? 'bg-pink-500' : isActive ? 'bg-orange-500' : 'bg-white bg-opacity-30'}`} data-id="element-814">
                {isCompleted ? <CheckIcon size={14} className="text-white" data-id="element-815" /> : <span className="text-xs text-white" data-id="element-816">{index + 1}</span>}
              </div>
              {/* Step label - only show for active and completed steps */}
              {(isActive || isCompleted) && <div className="absolute -bottom-6 text-center w-20" style={{
            left: '-30px'
          }} data-id="element-817">
                  <span className="text-xs text-white text-opacity-80" data-id="element-818">
                    {index === 0 ? 'Begin' : index === totalSteps - 1 ? 'Complete' : `Step ${index + 1}`}
                  </span>
                </div>}
            </div>;
      })}
      </div>
    </div>;
};
export default ProgressPath;